module.exports = "https://static.zego.com/_next/static/images/social-generic-d2890b0ad996f50a268ad2da814e2f9f.jpg";